
export enum InitiationStep {
  CONNECT_WALLET = 0,
  TOKEN_CHECK = 1,
  PATH_SELECTION = 2,
  TAKE_QUIZ = 3,
  TWITTER_ENGAGEMENT = 4,
  COMPLETION = 5,
}
